




















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';
import * as Components from '@/tenantCatalog/components';
import Moment from 'moment';

@Component
export default class BillingView extends Vue {
  public items: Common. Billing[] = new Array(0);
  public params: Common. BillingQuery = new Common.BillingQuery();
  public exportQuery = new Common.ExportQuery('月次請求', this.params);

  public sortOptions: any = [{ value: 'tenantId', text: 'テナントID' },{ value: 'tenantName', text: 'テナント名称' }];
  @Prop() public tenantId:string;
  @Prop() public closingDate:Date;

  public created(){
    if (this.tenantId) this.params.tenantId = this.tenantId;
    if (this.closingDate) this.params.closingDate = this.closingDate;
  }

  public getSelectedItems() : Common.Billing[]{
    return  (this.$refs.mainList as Components.ListView).selectedItems as Common.Billing[];    
  }
  public executeSettlement(){

    const items = this.getSelectedItems();
    if (items.length == 0) {
       this.$api.modal.show('カード決済処理(PayJP)','対象のテナントを選択してください。',true,null);
       return;
    }
    else if (items.filter(obj =>obj.tenant.paymentAgent != Common.paymentAgentFlags.payJp || obj.status != Common.billingFlags.billed ).length > 0) {
       this.$api.modal.show('カード決済処理(PayJP)','PayJP決済待ち以外のものは選択できません。',true,null);
       return;
    }

    this.$api.modal.show("カード決済処理(PayJP)","カード決済データを送信してよろしいですか？",false,()=>{
      this.$api.execute(new Common.SettlementQueryPayJP(items)).then(res=>{
          var links = [new Common.ModalLink(String.format('システムログ ID={0}',res),String.format('/operation/SystemLog?id={0}',res))];
          this.$api.modal.show('処理結果','バッチ処理が開始されました。\r\n処理結果は、以下のリンクから確認できます。',true,null,links);                    
        });
    });    
  }
  public showBillingItems(tenantId:string, closingDate:Date){
      this.$router.push(String.format('/project/billingItem?tenantId={0}&closingDate={1}',tenantId,Moment(closingDate).format("YYYY-MM-DD")));
  }
  public showPaymentItems(tenantId:string, closingDate:Date){
      this.$router.push(String.format('/project/paymentItem?tenantId={0}&closingDate={1}',tenantId,Moment(closingDate).format("YYYY-MM-DD")));
  }  
  public showTenant(tenantId:string){
      this.$router.push(String.format('/project/tenant?tenantId={0}',tenantId));
  }  

  public transferAmountExportDialog:boolean = false;
  public closingMonth:Date = null;
  // public showPaymentDialog(){
  //   var date1 = new Date().getCalendarDate();
  //   date1 = new Date(date1.getFullYear(),date1.getMonth(),1);
  //   // date1.setMonth(date1.getMonth()+1);
  //   date1.setDate(date1.getDate()-1);
  //   this.closingMonth = date1;
  //   this.transferAmountExportDialog = true;
  // }
  // public transferAmountExport(){
  //   this.$api.download(new Common.TransferAmountExportQuery('振替金額',new Common.TransferAmountLoadQuery(this.closingMonth)));
  // }
}
